import students25 from "./twf/students"   
import grades25 from "./twf/grades"
import gazette25 from "./twf/gazette"
import centers26 from "./tws/centers"
export default[
    ...students25,
    ...grades25,
    ...gazette25,
    ...centers26,

]